<template>
  <div class="app-container">
    <div class="filter-container">
      <span class="px-10">流水号</span>
      <el-input
        v-model="listQuery.log_no"
        placeholder="请输入流水号"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <span class="px-10">用户</span>
      <el-input
        v-model="listQuery.username"
        placeholder="请输入用户名称"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.last_name"
        placeholder="请输入姓"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.first_name"
        placeholder="请输入名"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.user_id"
        placeholder="请输入用户ID"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.uuid"
        placeholder="请输入UUID"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <span class="px-10">状态</span>
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        clearable
        style="width: 200px"
        class="filter-item"
      >
        <el-option label="未处理" value="none" />
        <el-option label="结算中" value="pending" />
        <el-option label="已入账" value="available" />
        <!-- <el-option label="可提现" value="available_unlock" /> -->
        <el-option label="部分撤销" value="partial_revoke" />
        <el-option label="已撤销" value="revoked" />
      </el-select>
      <span class="px-10 text-nowtap">积分类型</span>
      <el-select
        v-model="listQuery.reward_type"
        placeholder="积分类型"
        clearable
        style="width: 200px"
        class="filter-item"
      >
        <!-- <el-option label="零售奖励" value="money" /> -->
        <el-option label="RP" value="rp" />
        <el-option label="GP" value="hp" />
      </el-select>
      <span class="px-10">奖励类型</span>
      <el-select
        v-model="listQuery.revenue_type"
        placeholder="奖励类型"
        clearable
        style="width: 200px"
        class="filter-item"
      >
        <el-option label="零售奖励" value="retail_bonus" />
        <el-option label="分享奖励" value="referral_bonus" />
        <el-option label="建设奖励" value="distribution_bonus" />
        <el-option label="成长奖励" value="expansion_bonus" />
        <el-option label="扩展补充奖励" value="expansion_extra_bonus" />
        <el-option label="安心奖励" value="welfare_bonus" />
        <el-option label="创始人分红" value="founder_bonus" />
        <el-option label="VIP 分红" value="vip_bonus" />
        <el-option label="钻石分红" value="super_vip_bonus" />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="流水号" width="120">
        <template slot-scope="scope">
          {{ scope.row.log_no ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="用户ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_id }}
        </template>
      </el-table-column>
      <el-table-column label="UUID" min-width="130" align="center">
        <template slot-scope="scope">
          {{ scope.row.uuid }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="用户名称" width="120">
        <template slot-scope="scope">
          {{ scope.row.username || '' }}
        </template>
      </el-table-column>
      <el-table-column label="名" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.first_name || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="姓" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.last_name || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="奖励类型" min-width="110" align="center">
        <template slot-scope="scope">
          {{ revenue_type(scope.row.revenue_type) }}
        </template>
      </el-table-column>
      <el-table-column label="积分类型" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.reward_type === 'hp'" type="warning">
            GP
          </el-tag>
          <el-tag v-else-if="scope.row.reward_type === 'rp'" type="success"
            >RP</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="积分" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.reward_value }}
        </template>
      </el-table-column>
      <el-table-column label="关联订单号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_number }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" min-width="100">
        <template slot-scope="scope">
          <el-tag
            v-if="
              scope.row.status !== 'revoked' && scope.row.lock_status === 'lock'
            "
            type="danger"
          >
            已冻结
          </el-tag>
          <el-tag v-else-if="scope.row.status === 'none'" type="primary">
            未处理
          </el-tag>
          <el-tag v-else-if="scope.row.status === 'pending'" type="warning"
            >结算中</el-tag
          >
          <el-tag v-else-if="scope.row.status === 'available'" type="success"
            >已入账</el-tag
          >
          <el-tag
            v-else-if="scope.row.status === 'available_unlock'"
            type="success"
            >已入账</el-tag
          >
          <el-tag
            v-else-if="scope.row.status === 'partial_revoke'"
            type="warning"
            >部分撤销</el-tag
          >
          <el-tag v-else-if="scope.row.status === 'revoked'" type="warning"
            >已撤销</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="更新时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.updated_at ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="解冻时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.unlock_at ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="230"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            v-if="scope.row.status === 'pending'"
            @click="confirmPending(scope.row)"
          >
            手动确认结算
          </el-button>
          <!-- <el-button
            size="mini"
            type="warning"
            v-if="scope.row.status === 'available'"
            @click="confirmAvailable(scope.row)"
          >
            手动确认已入账
          </el-button> -->
          <el-button
            size="mini"
            type="danger"
            v-if="scope.row.status !== 'revoked'"
            @click="revoke(scope.row)"
          >
            退回
          </el-button>
          <div style="margin-top: 5px">
            <el-button
              size="mini"
              type="primary"
              v-if="
                scope.row.status !== 'revoked' &&
                scope.row.status !== 'available_unlock' &&
                scope.row.lock_status === 'unlock'
              "
              @click="lock(scope.row)"
            >
              冻结
            </el-button>
            <el-button
              size="mini"
              type="warning"
              v-if="
                scope.row.status !== 'revoked' &&
                scope.row.lock_status === 'lock'
              "
              @click="unlock(scope.row)"
            >
              解冻
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      title="驳回"
      :visible.sync="rejectModalVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      append-to-body
      width="512px"
    >
      <el-form
        ref="rejectForm"
        :model="rejectForm"
        :rules="rejectRules"
        label-width="0px"
      >
        <el-form-item prop="reason">
          <el-input
            type="textarea"
            placeholder="驳回理由"
            :rows="4"
            v-model="rejectForm.reason"
          ></el-input>
        </el-form-item>
        <el-row type="flex" justify="end">
          <el-button @click="rejectModalVisible = false">取消</el-button>
          <el-button type="primary" @click="reject('rejectForm')"
            >确认</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      rejectModalVisible: false,
      rejectRules: {
        reason: [
          { required: true, message: '请填写驳回理由', trigger: 'blur' },
        ],
      },
      rejectForm: {
        id: '',
        reason: '',
      },
      list: null,
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        log_no: '',
        user_id: '',
        username: '',
        status: '',
        revenue_type: '',
        reward_types: '',
      },
    }
  },
  created() {
    this.listQuery.reward_types = 'rp,hp'
    this.getList()
  },
  computed: {
    revenue_type() {
      return (val) => {
        switch (val) {
          case 'retail_bonus':
            return '零售奖励'
          case 'referral_bonus':
            return '分享奖励'
          case 'distribution_bonus':
            return '建设奖励'
          case 'expansion_bonus':
            return '成长奖励'
          case 'expansion_extra_bonus':
            return '扩展补充奖励'
          case 'welfare_bonus':
            return '安心奖励'
          case 'founder_bonus':
            return '创始人分红'
          case 'vip_bonus':
            return 'VIP 分红'
          case 'super_vip_bonus':
            return '钻石分红'
        }
      }
    },
  },
  watch: {
    rejectModalVisible() {
      this.rejectForm = {
        ...this.rejectForm,
        reason: '',
      }
    },
  },
  methods: {
    confirmPending(row) {
      this.$confirm('是否确认结算？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/revenueLog/confirmPending',
            method: 'post',
            data: {
              id: row.id,
            },
          }).then((res) => {
            console.log(res)
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    confirmAvailable(row) {
      this.$confirm('是否确认已入账？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/revenueLog/confirmAvailable',
            method: 'post',
            data: {
              id: row.id,
            },
          }).then((res) => {
            console.log(res)
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    revoke(row) {
      this.$confirm('是否确认退回？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/revenueLog/revoke',
            method: 'post',
            data: {
              id: row.id,
            },
          }).then((res) => {
            console.log(res)
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    lock(row) {
      this.$confirm('是否确认冻结？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/revenueLog/lock',
            method: 'post',
            data: {
              id: row.id,
            },
          }).then((res) => {
            console.log(res)
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    unlock(row) {
      this.$confirm('是否确认解冻？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/revenueLog/unlock',
            method: 'post',
            data: {
              id: row.id,
            },
          }).then((res) => {
            console.log(res)
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/revenueLog/list',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    edit(val) {
      this.$router.push('/member/editmemberinfo')
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
